type UnknownRecord = Record<string, unknown>
import { isEmpty } from 'remeda'

export const isDirtyFromUserInteraction = (
  formState:
    | {
        dirtyFields?: UnknownRecord
        touchedFields?: UnknownRecord
      }
    | undefined,
): boolean => !isEmpty(formState?.dirtyFields ?? {}) || !isEmpty(formState?.touchedFields ?? {})
